import { QueryResult, useQuery } from '@apollo/client';

import { GetParticipationsDocument } from '@/store/v2';

import { UsersPool, ParticipationGroup } from '@/types/analytics';

interface QueryParticipationsInput {
  userIdEq?: number;
  objectIdIn?: string[];
  objectTypeIn?: string[];
  objectTypeNin?: string[];
  isCompletedEq?: boolean;
  includeCatalogData?: boolean;
  usersPool?: UsersPool;
  orderBy?: string;
  from?: string;
  to?: string;
}

export function useQueryParticipations(
  input: QueryParticipationsInput,
  skip?: boolean,
): QueryResult<{ participations: ParticipationGroup[] }> {
  return useQuery<{ participations: ParticipationGroup[] }>(GetParticipationsDocument, {
    skip: skip,
    variables: {
      input: input,
    },
  });
}
